<script setup>
import logoSvg from "../assets/images/logo-icad.svg";
</script>
<template>
  <div class="container">
    <div class="header">
      <h1>Politique de confidentialité des chiens de protection</h1>
      <img :src="logoSvg" @click="router.push({ path: '/' })" />
    </div>

    <p>
      Le ministère de l’Agriculture et de l’Alimentation, agissant en qualité de
      Responsable de traitement, au sens du règlement européen n°2016-679 du 27
      avril 2016 et de la loi « Informatique et Libertés » du 6 janvier 1978
      modifiée (ci-après, ensemble, la « Règlementation ») attache une grande
      importance à la protection de vos données personnelles, et de votre vie
      privée.
    </p>

    <p>
      La présente politique (ci-après la « Politique ») a pour but de vous
      informer sur la manière dont nous collectons, utilisons et partageons les
      données personnelles que vous nous fournissez lors du recensement des
      chiens de protection.
    </p>

    <p>
      Cette Politique a vocation à s’appliquer uniquement aux traitements des
      informations (ci- après les « Données Personnelles ») susceptibles
      d’identifier ou de rendre identifiables les personnes concernées par le
      processus de recensement (ci-après les « Personnes concernées »),
      directement ou indirectement, à savoir les propriétaires et maitres des
      chiens recensé, les propriétaires d’exploitation, les maitres des parents
      des chiens recensés, mais également les recenseurs, les administrateurs de
      la base de données et les personnes ayant des habilitations pour l’accès à
      la base.
    </p>

    <p>
      Le ministère de l’Agriculture et de l’Alimentation s’engage à limiter les
      traitements sur les Données Personnelles aux seuls cas énumérés au sein de
      la présente Politique, et à mettre à jour cette dernière afin de garantir
      un haut niveau de protection des Données Personnelles en conformité avec
      la Règlementation applicable.
    </p>

    <h2>QUELLES DONNEES COLLECTONS NOUS ?</h2>
    <p>
      Lors du recensement des chiens de protection de troupeaux, vous pouvez
      être amenés à nous transmettre des Données Personnelles, directement ou
      indirectement.
    </p>
    <p>Ainsi, nous collectons vos données personnelles comme suit :</p>

    <ul>
      <li>
        Les Données Personnelles collectées, directement et indirectement, lors
        du recensement effectué par nos recenseurs ;
      </li>
      <li>
        Les Données Personnelles qui sont collectées lors du fonctionnement de
        l’application.
      </li>
    </ul>
    <p>Les Données Personnelles collectées pourront donc inclure :</p>

    <ul>
      <li>
        <strong>Des données d’identification </strong>: le nom, prénom,
        l’adresse e-mail, l’adresse postale, le numéro de téléphone…
      </li>
      <li>
        <strong>Des données liées à la vie professionnelle </strong>: N°EDE de
        l’exploitation, nom de l’exploitation, nom de l’entreprise, e-mail
        professionnel, profession…
      </li>
      <li>
        <strong>Des données économiques</strong> : données relatives aux
        caractéristiques de l’exploitation…
      </li>
      <li>
        <strong>Des données concernant la vie personnelle </strong>: présence
        d’enfants sur l’exploitation…
      </li>
      <li>
        <strong>Des données relatives aux caractéristiques animales  </strong>:
        numéro d’identification, numéro de LOF, par croisement toute donnée
        permettant d’identifier une personne physique ;
      </li>
      <li>
        <strong>Des données de connexion et de navigation</strong> : login,
        identifiant, adresse IP, cookies fonctionnels
      </li>
    </ul>

    <p>
      Lors de la collecte de vos Données Personnelles, vous pouvez être informés
      du fait que certaines d’entre elles doivent impérativement être
      renseignées afin de parvenir au résultat attendu. A défaut de renseigner
      ces informations obligatoires, l’exécution de la demande pourra s’avérer
      impossible.
    </p>

    <h2>POUR QUELLES RAISONS COLLECTONS NOUS VOS DONNEES PERSONNELLES ?</h2>
    <p>
      Nous collectons et traitons vos Données Personnelles pour les finalités
      suivantes :
    </p>
    <ul>
      <li>
        Afin de recenser et caractériser les chiens de protection pour disposer
        d’une photographie de la population nationale ;
      </li>
      <li>Afin de créer une filière d’éleveurs naisseurs ;</li>
      <li>
        Afin de disposer d’un outil pour à terme mettre en place une démarche de
        sélection ;
      </li>
      <li>Afin de répondre aux demandes des personnes concernées ;</li>
      <li>
        Afin d’assurer un support technique et une maintenance au bon
        fonctionnement de l’application développée ;
      </li>
      <li>Afin d’anticiper et de résoudre les éventuels litiges.</li>
    </ul>

    <h2>SUR QUELLE BASE LEGALE COLLECTONS-NOUS VOS DONNEES PERSONNELLES ?</h2>

    <p>
      Nous collectons et traitons vos Données Personnelles dans le respect de la
      Règlementation, et seulement dans le cadre de notre mission d’intérêt
      public qui se base sur le plan national d’action pour le loup et les
      activités d’élevage 2018/2023.
    </p>

    <h2>QUELS SONT VOS DROITS SUR VOS DONNEES PERSONNELLES ?</h2>

    <p>
      Vous pouvez à tout moment exercer vos droits qui vous sont octroyés par la
      Règlementation :
    </p>

    <ul>
      <li>Demander l’accès à vos Données Personnelles ;</li>
      <li>
        Demander la rectification des Données Personnelles inexactes vous
        concernant ;
      </li>
      <li>Obtenir l’effacement de vos Données Personnelles ;</li>
      <li>Restreindre notre traitement de vos Données Personnelles ;</li>
      <li>Vous opposez au traitement de vos Données Personnelles ;</li>
    </ul>

    <p>
      Pour exercer ces droits, vous pouvez nous contacter à l’adresse suivante
      rgpd.cdp@ingenium.fr ou par courrier postal : CHIENS DE
      PROTECTION INGENIUM ANIMALIS 112/114 avenue Gabriel Péri 94240
      L’Haÿ-les-Roses.
    </p>

    <h2>QUI SONT LES DESTINATAIRES DE VOS DONNEES PERSONNELLES ?</h2>

    <p>
      Les Données Personnelles de nos Utilisateurs sont strictement
      confidentielles et destinées exclusivement au Ministère de l’Agriculture
      et de l’Alimentation. Les Données collectées nous sont destinées en notre
      qualité de responsable de traitement.
    </p>

    <p>
      Sauf obligation légale, comptable ou judiciaire, nous ne divulguerons,
      louerons, céderons ou transmettrons de quelque manière que ce soit vos
      Données Personnelles à des tiers autres que :
    </p>

    <p>
      Le Ministère de la Transition Ecologique en tant que destinataire des
      rapports et des statistiques élaborés ;
    </p>

    <p>
      INGENIUM ANIMALIS, en sa qualité de sous-traitant, chargé de la
      maintenance et de l’administration de la base de données des chiens de
      protections, ainsi que de la gestion des demandes des droits des personnes
      concernées dans le cadre de la règlementation relative à la protection des
      données personnelles ;
    </p>
    <p>
      Les administrateurs de la base de données désignés par LA PASTORALE
      PYRENEENNE et de L’INSTITUT D’ELEVAGE ;
    </p>
    <p>
      Les agents recenseurs membres de la PASTORALE PYRENEENNE et de l’INSTITUT
      D’ELEVAGE ;
    </p>
    <p>
      Les agents recenseurs et relais locaux membres de la PASt=TOTALE
      PYRENEENNE et de l’INSTITUT D’ELEVAGE ;
    </p>
    <p>
      DEGETEL, en sa qualité de sous-traitant ultérieur, chargé de la tierce
      maintenance applicative ;
    </p>
    <p>
      OVH, en sa qualité de sous-traitant ultérieur, chargé de l’hébergement de
      la base de données.
    </p>

    <h2>OÙ TRANSFÉRONS NOUS VOS DONNÉES PERSONNELLES ?</h2>

    <p>
      Vos données ne font pas l’objet de transferts hors du territoire de
      l’Union Européenne.
    </p>

    <h2>COMBIEN DE TEMPS CONSERVONS NOUS VOS DONNEES PERSONNELLES ?</h2>
    <p>
      Vos Données Personnelles ne sont conservées que pour la durée strictement
      nécessaire à la réalisation des finalités poursuivies, telles qu’édictées
      par la présente Politique, et ce conformément à la Règlementation et aux
      lois applicables.
    </p>
    <p>Passé ce délai, vos Données Personnelles seront supprimées.</p>

    <table>
      <tr>
        <th>Données concernées</th>
        <th>Finalités du traitement</th>
        <th>Durées de conservation</th>
      </tr>
      <tr>
        <td>Données relatives au recensement</td>
        <td>
          Recenser et caractériser les chiens de protection <br />
          Création d’une filière d’éleveurs naisseurs
        </td>
        <td>15 ans</td>
      </tr>
      <tr>
        <td>Données de connexion à l’application</td>
        <td>Journalisation : traçabilité des actions</td>
        <td>12 mois</td>
      </tr>
      <tr>
        <td>Données relatives aux recenseurs et aux administrateurs</td>
        <td>Gestion des recensements</td>
        <td>
          Jusqu’à la demande de suppression et le temps de la durée de vie de
          l’animal recensé
        </td>
      </tr>
    </table>

    <h1>MODIFICATION DE NOTRE POLITIQUE DE CONFIDENTIALITE</h1>

    <p>
      Nous pouvons être amenés à modifier occasionnellement la présente
      Politique, afin de nous conformer aux évolutions réglementaires,
      jurisprudentielles, éditoriales ou techniques.
    </p>
    <p>
      Le cas échéant, nous changerons la date de « dernière mise à jour » et
      indiquerons la date à laquelle les modifications ont été apportées.
    </p>
    <p>
      Lorsque cela s’avère nécessaire, nous vous informerons et / ou
      solliciterons votre accord.
    </p>
    <p>
      Nous vous conseillons de consulter régulièrement cette page afin de
      prendre connaissance des éventuelles modifications ou mises à jour
      apportées à notre Politique.
    </p>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/css/_variables.scss";

.container {
  display: flex;
  flex-direction: column;
  padding: 20px 40px;

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    h1 {
      font-size: 30px;
      margin-top: 0px;
      margin-bottom: 0px;
    }
  }

  h2 {
    margin-top: 10px;
    margin-bottom: 0px;
    font-size: 25px;
  }

  p {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 17px;
  }

  table,
  th,
  td {
    border: 1px solid black;
    border-collapse: collapse;
  }
}
</style>
